import List from "@mui/material/List";
import { useCartContext } from "vino/context";
import CartProductItem from "./CartProductItem";
import CartFooter from "./CartFooter";

const CartProductsTable = () => {
	const { cartLineItems } = useCartContext();

	return (
		<List className="p-0">
			{cartLineItems.map((item) => (
				<CartProductItem key={item.variantId} lineItem={item} />
			))}

			<CartFooter />
		</List>
	);
};

export default CartProductsTable;
